import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const APP_DESCRIPTION_UPDATE = gql(`
  mutation appDescriptionUpdate($organizationSlug: String!, $appID: ID!, $appDescription: String) {
    appDescriptionUpdate(organizationSlug: $organizationSlug, appData:  {
       appID: $appID,
       appDescription: $appDescription
    }) {
      __typename
      id
      description
    }
  }
`);

export function useAppDescriptionUpdate() {
  return useMutation(APP_DESCRIPTION_UPDATE);
}
